<template>
  <div>
    <loading :active="isLoading" loader="dots" color="#ff6602" />
    <router-view></router-view>
  </div>
</template>
<style>
.avatar-lg {
  width:100px;
}
</style>
<script>
import {mapGetters} from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  computed: {
    ...mapGetters({
      isLoading: 'orders/isLoading'
    })
  },
  created: function () {
    let that = this;
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          that.$store.dispatch('auth/signOut')
        }
        throw err;
      });
    });
    this.axios.interceptors.request.use((config) => {
      this.$store.dispatch('orders/loading', true);
      return config;
    }, (error) => {
      this.$store.dispatch('orders/loading', false);
      return Promise.reject(error);
    });

    this.axios.interceptors.response.use((response) => {
      this.$store.dispatch('orders/loading', false);
      return response;
    }, (error) => {
      this.$store.dispatch('orders/loading', false);
      return Promise.reject(error);
    });
  },
  mounted() {
  }
}
</script>
